module.exports = __webpack_public_path__ + "img/icon-files.f6f129bd.svg";